var tag = document.createElement('script'), 
firstScriptTag = document.getElementsByTagName('script')[0], 
player = new Array(), 
theID, 
checkCurrentTime,
vimeo_player = {},
youtubeReady = false,
$ = jQuery;

//Just a little hack to stop related videos from showing when the video has finished
function whilePlayBack(event){
    var $duration = event.target.getDuration(); $duration -= 1;checkCurrentTime = setTimeout(function(){
    if(event.target.getCurrentTime() >= $duration){event.target.stopVideo();}whilePlayBack(event);},100);
}

function onPlayerStateChange(event){
    if(event.data == 1){
        whilePlayBack(event);
    } else {
        clearTimeout(checkCurrentTime);
    }
}

//Add Youtube and Vimeo API
$(document).ready(function(){
    tag.src = "https://www.youtube.com/iframe_api";
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
});



$('.vimeo').each(function(){
    var theId = $(this).attr('id');
    var iframe = document.getElementById(theId);
    
    vimeo_player[theId] = $f(iframe);
});

if($('.youtube').length == 0){
    youtubeReady = true;
}

function onYouTubeIframeAPIReady() {
    $('.youtube').each(function(){
        var ytid = $(this).attr('data-ytid'),
        ytcontrols = typeof $(this).attr('data-controls') != 'undefined' ? $(this).attr('data-controls')  : 0;
        muted = typeof $(this).attr('data-muted') != 'undefined' ? $(this).attr('data-muted')  : 0;
        playsinline = typeof $(this).attr('data-playsinline') != 'undefined' ? $(this).attr('data-playsinline') : 0;
        loop = typeof $(this).attr('data-loop') != 'undefined' ? $(this).attr('data-loop') : 0;
        autoplay = typeof $(this).attr('data-autoplay') != 'undefined' ? $(this).attr('data-autoplay') : 0,
        youtubeReady = true;

        /* Slick slider videos do not need to worry about related videos at the end as they
        are designed to loop, on mute - mainly for header sliders. Plus Youtube functions
        don't seem to work with them */
        if($(this).closest('.slick-slide').length){
            player = new YT.Player(ytid, {
                playerVars: {
                    'rel': 0,
                    'iv_load_policy': 3,
                    'playsinline': 1,
                    'origin': window.location.hostname,
                    'controls': ytcontrols,
                    'playsinline': playsinline,
                    'loop': loop,
                    'disablekb': 1,
                    'fs': 0,
                },
                videoId: ytid,
                events: {
                    'onReady': onPlayerReady
                }
            });
        } else {
            player = new YT.Player(ytid, {
                playerVars: {
                    'rel': 0,
                    'iv_load_policy': 3,
                    'playsinline': 1,
                    'origin': window.location.hostname,
                    'controls': ytcontrols,
                    'playsinline': playsinline,
                    'loop': loop,
                    'disablekb': 1,
                    'fs': 0,
                },
                videoId: ytid,
                events: {
                    'onReady': onPlayerReady,
                    'onStateChange': onPlayerStateChange,
                }
            });
        }

        function onPlayerReady(event) {
            if(muted == 1){
                event.target.mute();
            }
            if(autoplay == 1){
                event.target.playVideo();
            }
        }
    });
}


$(document).on('click','.video-embed-container .play', function(){
    if($(this).hasClass('html5')){
        $(this).siblings('video').get(0).play();
    } else if($(this).hasClass('youtube_play')){
        var ytid = $(this).parent().siblings('.youtube').attr('id');
        $(this).parent().fadeOut(1000);
        ytid = $('#'+ytid);
        ytid[0].contentWindow.postMessage(`{
            "event":"command",
            "func":"${'playVideo'}",
            "args":""
        }`, '*');
    } else if($(this).hasClass('vimeo_play')){
        var vid = $(this).parent().siblings('.vimeo').attr('id');
        $(this).parent().fadeOut(1000);

        vimeo_player[vid].api('play');
    }

    return false;
});

function pauseVideo($button) {
    if($button.hasClass('html5')){
        $button.siblings('video').get(0).pause();    
    } else if($button.hasClass('youtube_play')){
        var ytid = $button.parent().siblings('.youtube').attr('id');
        $button.parent().fadeIn(1000);
        
        ytid = $('#'+ytid);
        ytid[0].contentWindow.postMessage(`{
            "event":"command",
            "func":"${'pauseVideo'}",
            "args":""
        }`, '*');
    } else if($button.hasClass('vimeo_play')){
        var vid = $button.parent().siblings('.vimeo').attr('id');
        $button.parent().fadeIn(1000);
        vimeo_player[vid].api('pause');
    }

    return false;
}


$(document).ready(function(){
    $('video').each(function(){
        var video = $(this).get(0);
        video.onplay = function() {
            $(this).siblings('.play').fadeOut(1000);
        }
        video.onpause = function() {
            $(this).siblings('.play').fadeIn(0);
        } 
    });


    $(window).on('scroll load', function(){
        if(youtubeReady == true){
            var scrollMiddle = $(window).scrollTop() + ($(window).innerHeight() / 2),
            offset = $(window).height() / 4;
            theMiddle = 0;

            $('.video-embed-container').each(function() {
                var ele = $(this);
                theMiddle = ele.offset().top + (ele.height() / 2);
                
                if(theMiddle > (scrollMiddle - offset) && theMiddle < (scrollMiddle + offset) ){
                    if(ele.find('.autoplayscroll').length){
                        ele.find('.play').trigger('click');
                    }
                } else {
                    pauseVideo( ele.find('.play') );
                }
            });
        }
    });

});